<template>
  <NoticeItem
    :notice-detail="noticeDetail"
    :icon="iconNotice"
    :title="ApplicationManager.getAppName(noticeDetail.appId)"
    :on-close-icon-click="onCloseIconClick"
    :shadow="isSingleOne"
    :auto-close="autoClose"
  >
    <div style="word-break: break-all">
      {{ $t(noticeDetail.msg, { default: noticeDetail.msg }) }}
    </div>
    <template v-if="noticeDetail.type == NoticeType.COMMON_ACTION" #footer>
      <a-button @click.stop="onActionButtonClick">
        {{ noticeDetail.actionBtnLabel || getDefaultButtonLabel(noticeDetail.action) }}
      </a-button>
    </template>
  </NoticeItem>
</template>

<script lang="ts">
  const ON_ACTION_BUTTON_CLICK = 'on-action-button-click'
</script>

<script lang="ts" setup>
  import NoticeItem from './NoticeItem.vue'
  import type { PropType } from 'vue'
  import { onMounted } from 'vue'
  import { Action, NoticeType } from '@/core/databus/IMessage'
  import iconNotice from '@assets/svgs/icon-notice.png'
  import { INSTANCE as GuideManager } from '@/core/GuideManager'
  import { INSTANCE as ApplicationManager } from '@core/application/ApplicationManager'
  import type { ActionNotice } from '@/core/Notification/NotificationManager'
  import { INSTANCE as NotificationManager } from '@/core/Notification/NotificationManager'
  import { useNoticeActionButton } from '@/core/compositions/NoticeActionButton'
  import { PageManager } from '@/core/application/PageManager'
  import { useOtrack } from '@/core/compositions/Otrack'
  import { TrackEventMap } from '@/core/TrackConstants'
  import { MicroAppId } from '@core/application/ApplicationConstants'
  import { INSTANCE as WindowPopperManager } from '@/core/WindowPopperManager'
  import { MainHeaderItems, useSharedActiveMainHeaderItem } from '@/core/compositions/ActiveMainHeaderItem'
  import { readCompressionNotice } from '@/core/transmission/DownloadTaskZip'
  import { delay } from 'lodash-es'

  const props = defineProps({
    noticeDetail: {
      type: Object as PropType<ActionNotice>,
      default: null,
    },
    isSingleOne: {
      type: Boolean,
      default: true,
    },
  })

  const { track } = useOtrack()
  const emit = defineEmits([ON_ACTION_BUTTON_CLICK])

  const { getDefaultButtonLabel } = useNoticeActionButton()

  const removeNotice = () => {
    NotificationManager.removeNotice([props.noticeDetail])
  }

  const onCloseIconClick = () => {
    removeNotice()
  }

  const autoClose = () => {
    NotificationManager.dismissFloatNotice()
  }

  onMounted(() => {
    console.log(props.isSingleOne, props.noticeDetail)
  })
  const { updateCurrentSelectedItem } = useSharedActiveMainHeaderItem()

  const onActionButtonClick = () => {
    const { action, pagePath, extraQuery = '', appId } = props.noticeDetail
    const params = new URLSearchParams(extraQuery)

    switch (action) {
      //页面跳转
      case Action.NAV_TO:
        const route = `${pagePath}?${extraQuery}`
        const pageManager = new PageManager(appId)

        pageManager.openInNewWindow(route)

        if (appId === MicroAppId.FILE_MANAGER) {
          track({
            eventId: TrackEventMap.NOTIFICATION_OPEN_SHARED_FILE,
          })
        }
        break
      //添加设备
      case Action.GUIDE_DEVICE_ADDING:
        GuideManager.showDeviceGuide()
        break
      // 局域网证书
      case Action.LAN_PROMPT:
        console.log('params.get:', params.get('deviceId'))

        WindowPopperManager.show(params.get('deviceId') ?? undefined)
        break
      case Action.VIEW_TRANSMISSION:
        const taskId = params.get('taskId')

        taskId && readCompressionNotice(taskId)
        updateCurrentSelectedItem(undefined)
        delay(() => {
          updateCurrentSelectedItem(MainHeaderItems.TRANSMISSION_LIST, extraQuery)
        }, 200)
        break
      default:
        break
    }
    removeNotice()
    emit(ON_ACTION_BUTTON_CLICK)
  }
</script>
